import { render } from "./suscribirseScreen.vue?vue&type=template&id=3610a198&scoped=true"
import script from "./suscribirseScreen.vue?vue&type=script&lang=js"
export * from "./suscribirseScreen.vue?vue&type=script&lang=js"

import "./suscribirseScreen.vue?vue&type=style&index=0&id=3610a198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3610a198"]])

export default __exports__